import { render, staticRenderFns } from "./global-button-directory.vue?vue&type=template&id=8aa4b6a4&scoped=true&"
import script from "./global-button-directory.vue?vue&type=script&lang=js&"
export * from "./global-button-directory.vue?vue&type=script&lang=js&"
import style0 from "./global-button-directory.vue?vue&type=style&index=0&id=8aa4b6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa4b6a4",
  null
  
)

export default component.exports